<template>
  <div class="applyAudit">
    <template v-if="isApplyAudit">
      <ots-tipline :isTopLine="true" v-show="isCanHandle">
        当前批次报名审核截止时间为<span>{{endAudit}}</span> ,请尽快完成审核
      </ots-tipline>
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <ots-table-group-new
        ref="ots-table"
        :selectList="teaSelectList"
        :requestForm='requestForm'
        @search="search"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :tableOption="tableOption"
        :batchOperBtn="batchOperBtn"
        :isDisabledMultiple="isDisabledMultiple" 
        @handleSelectionChange="bachOper"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
        @changeCity="changeCityFN"
      ></ots-table-group-new>
      <ots-custom-dialog :dialog.sync="applyMsgDialog" title="报名信息审核">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm">
              <el-form-item label="驳回原因">
                <el-input type="textarea" v-model="ruleForm.reason"></el-input>
              </el-form-item>
              <el-form-item label="重新提交报考信息">
                <el-radio-group v-model="ruleForm.flag">
                  <el-radio-button :label='0'>允许</el-radio-button>
                  <el-radio-button :label='1'>不允许</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="applyMsgDialog=false">取消</el-button>
          <el-button round type="primary" @click="rightAudit">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>

    <template v-else>
      <router-view></router-view>
    </template>
    <ots-custom-dialog :dialog.sync="importDialog" title="导入审核信息" width="40%">
        <template v-slot:content>
            <div class="exportDialog">
                <el-form ref="exportForm" :model="importForm">
                    <el-form-item label="1.模板下载说明">
                        <span>
                            可先根据查询条件导出所需的数据，修改后进行上传。
                        </span>
                    </el-form-item>
                    <el-form-item label="2.选择文件" v-model="importForm.file">
                        <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                    </el-form-item>
                </el-form>
                <div class="impExplain">
                    <span class="tipTitle"><i></i>提示：</span>
                    <div>
                        <div>1：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <el-button round @click="importDialog=false">取消</el-button>
            <el-button round type="primary" @click="rightImport">确定</el-button>
        </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import { getSinglePlan } from '@/http/modules/examSet/examBatch'
  import { examineList, exportExamine } from "@/http/modules/custom"

  export default {
    name: 'applyAudit',
    data() {
      return {
        currentPlanId: '',
        importDialog: false,
        mainTopBtnList: [
          {
            title: "导出",
            fn: this.exportInfo
          },
        ],
        endAudit: "",
        endAuditTime: "",
        applyMsgDialog: false,
        ruleForm: {
          isAudit: 2,
          flag: 0,
          reason: '',
          planId: '',
          state: 0,
          stuId: '',
        },
        requestForm: {
          page: 1,
          isAudit: 2,
          size: 10, //每页条数
          planId: "", //批次Id
          schoolId: "", // 学校
          stationId: [''], // 函授站
          orders: "",
          stateType: '3', // 审核状态--默认待终审
          photoState: "", // 人身核验状态
          realName: "",
          cardNo: "",  //证件号
          phone: "",
        },
        stuIds: [],
        teaSelectList: [
          {
            title: "考试批次",
            type: "select",
            requestKey: "planId",
            label: "name",
            value: "id",
            data: [],
          },
          {
            title: "审核状态",
            type: "select",
            requestKey: "stateType",
            label: "name",
            value: "id",
            data: [
              {
                id: "",
                name: "全部",
              },
              {
                id: "3",
                name: "待终审",
              },
              {
                id: "4",
                name: "终审通过",
              },
              {
                id: "5",
                name: "终审不通过",
              },
            ],
          },
          {
            title: "人身核验状态",
            type: "select",
            isSearch: true,
            requestKey: "photoState",
            label: "name",
            value: "id",
            data: [
              {
                id: "",
                name: "全部",
              },
              {
                id: 1,
                name: "系统通过",
              },
              {
                id: 0,
                name: "系统不通过",
              },
              {
                id: 2,
                name: "人工通过",
              },
            ],
          },
          {
            title: "院校",
            type: "select",
            isSearch: true,
            requestKey: "schoolId",
            label: "name",
            value: "id",
            data: [
              {
                id: "",
                name: "全部",
              }
            ],
          },
          {
            title: '函授站',
            type: 'select',
            requestKey: "stationId",
            isSearch: true,
            multiple: true,
            label: "name",
            value: "id",
            data: [
              {
                id: "",
                name: "全部",
              },
            ],
          },
          {
            title: '姓名',
            type: 'input',
            requestKey: 'realName',
            placeholder: '请输入'
          },
          {
            title: '证件号',
            type: 'input',
            requestKey: 'cardNo',
            placeholder: '请输入'
          },
          {
            title: '手机号',
            type: 'input',
            requestKey: 'phone',
            placeholder: '请输入'
          },
        ],
        tableHeader: [
          {
            title: "姓名",
            prop: "realName",
            width: "80",
            fixed : 'left'
          },
          {
            title: "院校",
            prop: "school",
            width: "200"
          },
          {
            title: "函授站",
            prop: "station",
            width: "200"
          },
          {
            title: "证件号",
            prop: "cardNo",
            width:'200'
          },
          {
            title: "手机号",
            prop: "phone",
            width:'115'
          },
          {
            title: "报考课程",
            prop: "course",
            width : '100'
          },
          {
            title: "照片",
            type: "img",
            prop: "photo",
            fixed : 'right'
          },
          {
            title: "人身核验状态",
            prop: "photoState",
            type: 'state',
            stateFlag: (scope) => { 
              const options = {
                '人工通过': 'green',
                '系统通过': 'green',
                '系统不通过': 'red',
                '无照片': 'red'
              }
              return options[scope.row.photoState]
            },
            width: "120",
            fixed : 'right'
          },
          {
            title: "审核状态",
            prop: "stateType",
            type: 'state',
            stateFlag: (scope) => {
              //待初审、初审不通过、待终审、终审通过、终审不通过
              const options = {
                '待初审': 'orange',
                '初审不通过': 'red',
                '待终审': 'orange',
                '终审通过': 'green',
                '终审不通过': 'red',
              }
              return options[scope.row.stateType]
            },
            fixed : 'right',
            width : '110'
          },
          {
            title: "操作",
            type: "buttons",
            width: "165",
            fixed: 'right',
            btnList: [
              {
                title: '通过',
                // title: (scope) => {
                //   let { stateType } = scope.row
                //   return !(stateType === '待终审' && this.isCanHandle) ? '' : '通过'
                // },
                formatter: (scope) => {
                  let { stateType } = scope.row
                  return !(stateType === '待终审' && this.isCanHandle)
                },
                click: this.pass
              },
              {
                title: '驳回',
                // title: (scope) => {
                //   let { stateType } = scope.row
                //   return !(stateType === '待终审' && this.isCanHandle) ? '' : '驳回'
                // },
                formatter: (scope) => {
                  let { stateType } = scope.row
                  return !(stateType === '待终审' && this.isCanHandle)
                },
                click: this.unpass
              },
              {
                title: "撤销审核",
                // title: (scope) => {
                //   let { stateType } = scope.row
                //   if ((stateType === '终审通过' || stateType === '终审不通过') && this.isCanHandle) {
                //     return '撤销审核'
                //   } else {
                //     return ''
                //   }
                // },
                formatter: (scope) => {
                  let { stateType } = scope.row
                  if ((stateType === '终审通过' || stateType === '终审不通过') && this.isCanHandle) {
                    return false;
                  } else {
                    return true;
                  }
                },
                click: this.revokeState
              },
              {
                title: '审核详情',
                click: this.lookDetail
              },
            ]
          }
        ],
        tableData: [],
        tableOption: {
          multiple: true
        },
        batchOperBtn: [
          {
            title: "批量审核通过",
            icon: "iconfont icon-kaiqi",
            click: this.exportUser
          }
        ],
        pagination: {
          total: 0
        },
        importForm: {
          file: ''
        },
        customSearch:[],
        currentTime: '',
      }
    },
    computed: {
      isApplyAudit() {
        return this.$route.name === 'applyAudit'
      },
      isOverAudit () {
        return new Date(this.currentTime).getTime() > new Date(this.endAuditTime).getTime()
      },
      isCurrentPlan() {
        return this.requestForm.planId == this.currentPlanId
      },
      isCanHandle() {
        return !this.isOverAudit && this.isCurrentPlan
      }
    },
    watch: {
      '$route': function (val) {
        if (val.name == 'applyAudit') {
          this.getTableList()
        }
      },
      'requestForm.planId': function (val) {
        this.isPlanChange = true
        this.search()
      }
    },
    mounted() {
      this.getData()
      this.dealTableBtn()
      this.isSetState()
    },
    methods: {



      /***********************************
       * @isSetState 系统是否设置了函授站标题
       ***********************************/
      isSetState(){
        this.mixin_getServerTime().then(res => {
          if (res.code == 1) {
            this.currentTime =  res.data;
          }
        })
        // this.$api.system.getConfigData().then(res=>{
        //   let stationName = '';
        //   res.data.configList.map(e=>{
        //     if ( e.setName == "stationName" ) {
        //       stationName = e.setValue2;
        //     }
        //   });
        //   if ( stationName ) {
        //     this.teaSelectList[4].title = stationName;
        //     this.tableHeader[2].title = stationName;
        //   } else {
        //     this.teaSelectList[4].title = "函授站";
        //     this.tableHeader[2].title = "函授站";
        //   }
        // })
        this.teaSelectList[4].title = "函授站";
        this.tableHeader[2].title = "函授站";
      },

      /*****************************************
       * @changeCityFN 子组件传递方法,地址数据处理
       *****************************************/
      changeCityFN(e, attr){
          this.requestForm[attr] = e.toString();
      },
      
      // 批次信息
      getPlanInfo (planId) {
        getSinglePlan({planId}).then(({ data }) => {
          this.endAuditTime = data.endAudit
          this.isPlanChange = false
        })
      },

      dealTableBtn () {},

      revokeState (row) {
        let { planId, stuid } = row
        this.$confirm('确定要撤销审核吗？', '撤销审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return this.$api.applyAudit.backExamineFn({
            isAudit: 2,
            planId,
            stuId: stuid
          })
        }).then((res) => {
          if (res.code) {
            this.$message.success('撤销成功')
            this.getTableList()
          }
        }).catch(() => {
        });
        
      },

      exportInfo () {
        let params = { ...this.requestForm };
        params.stationId = params.stationId.join();
        exportExamine(params).then(res => {
          if (res.code == 1) {
            window.location.href = res.data
          }
        })
      },

      importInfo () {
        this.importDialog = true
      },

      handleFormData (val) {
          this.importForm.file = val.file
      },

      rightImport () {
          if (!this.importForm.file) {
              this.$message.error('请选择文件')
              return
          }
          const fd = new FormData()
          for (let item in this.importForm) {
              fd.append(item,this.importForm[item])
          }
          this.$api.applyAudit.importStudentStatus(fd).then(res => {
            if (res.code == 1) {
              let data = res.data
              const failNum = data.errorCount ? parseInt(data.errorCount) : 0
              const totalNum = parseInt(data.allCount)
              const successNum = totalNum - failNum

              let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`
              this.importDialog = false

              this.$confirm(message, '导入结果', {
                  confirmButtonText: failNum > 0 ? '查看错误记录' :'确定',
                  cancelButtonText: '取消',
                  type: failNum > 0 ? 'warning' :'success'
              }).then(async () => {
                  if (failNum > 0) {
                      window.location.href = data.address
                  }
              }).catch(() => {
              });
              this.getTableList()
            }
          })
      },

      isDisabledMultiple (row) {
        let { stateType } = row;
        if (stateType == '待终审' && this.isCanHandle) {
          return true
        }
        return false
      },

      getTableList() {
        for ( let key in this.requestForm ) {
          if ( this.requestForm[key] == "全部" ) {
            this.requestForm[key] = '';
          }
        };
        if (this.isPlanChange) {
          this.getPlanInfo(this.requestForm.planId)
        }

        /* *** 修改: 函授站搜索为多选 *** */
        let params = { ...this.requestForm };
        if (typeof(params.stationId) == 'object') {
          params.stationId = params.stationId.join(',');
        }
        
        examineList(params).then(res => {
          if (res.code) {
            this.tableData = res.data.records
            this.pagination.total = res.data.total
            res.data.records.forEach( e => {
              e.extData.forEach( item=> {
                e[item.name] = item.value;
              })
            })
          }
        })
      },

      bachOper(val) {
        this.stuIds = []
        let idList = []
        val.forEach(item => {
          idList.push(item.stuid)
        })
        this.stuIds = idList
      },

      exportUser() {
        if (this.stuIds.length < 1) {
          this.$message({
            message: "请选择要通过的学生",
            type: 'warning'
          });
          return
        }
        this.$confirm(`确认将选中${this.stuIds.length}名学生审核通过`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let queryImport = {
            isAudit: 2,
            planId: this.requestForm.planId,
            stuIds: this.stuIds + ''
          }
          this.$api.applyAudit.batchExamine(queryImport).then(res => {
            if (res.code) {
              this.$message({
                message: "审核通过",
                type: 'success'
              });
              this.getTableList()
            }
          })
        }).catch(() => {
        })
      },

      search() {
        this.requestForm.page = 1
        this.getTableList()
      },

      changeNum(num) {
        this.requestForm.size = num
        this.getTableList()
      },

      changePage(p) {
        this.requestForm.page = p
        this.getTableList()
      },

      examine() {
        this.$api.applyAudit.examine(this.ruleForm).then(res => {
          if (res.code) {
            this.applyMsgDialog = false
            this.$message({
              message: this.ruleForm.state ? '审核不通过' : "审核通过",
              type: this.ruleForm.state ? 'error' : 'success'
            });
            this.getTableList()
          }
        })
      },

      pass(val) {
        let {planId, stuid} = val
        this.ruleForm.planId = planId
        this.ruleForm.stuId = stuid
        this.ruleForm.state = 0
        this.examine()
      },

      unpass(val) {
        this.ruleForm = {
          isAudit: 2,
          flag: 0,
          reason: '',
          planId: '',
          state: 1,
          stuId: '',
        },
          this.applyMsgDialog = true
        let {planId, stuid} = val
        this.ruleForm.planId = planId
        this.ruleForm.stuId = stuid

      },

      rightAudit() {
        this.examine()
      },

      lookDetail(val) {
        let { planId, stuid} = val
        this.$router.push({
          path: '/applyAudit/applyAuditDetail',
          query: {planId, stuid, isCanHandle: this.isCanHandle}
        })
      },
      
      getData () {
        this.mixin_setUserExtInfo().then(res=>{
          res.data.map(item=>{
            if ( item.queryCondition == 1 ) {
                if ( item.type == 'select' || item.type == 'province' || item.type == 'subject' || item.type == 'nation' || item.type == 'politicalStatus' || item.type == 'level' ) {
                  if ( item.valueVo ) {
                    let search = {
                      title: item.displayName,
                      type: 'select',
                      requestKey: item.name,
                      label: 'name',
                      value: 'name',
                      data: [
                        {
                          name: "全部",
                        },
                        ...item.valueVo
                      ],
                    };      
                    this.customSearch.push(search);                         
                  }
                } else if (item.type == 'text') {
                  let search = {
                    title: item.displayName,
                    type: 'input',
                    requestKey: item.name,
                    placeholder: '请输入',
                  };
                  this.customSearch.push(search);
                } else if ( item.type == "provinceCity" ) {
                    let search = {
                      title: item.displayName,
                      type: 'cascader',
                      requestKey: item.name,
                      label: 'name',
                      value: 'name',
                      data: [
                        {
                          name: "全部",
                        },
                        ...item.valueVo
                      ],
                    };  
                    this.customSearch.push(search);
                };
            };
            // table 表格数据
            if (item.type == 'imageUpload') {
              let tables = {
                title: item.displayName,
                type: 'img',
                width: "120",
                prop: item.name,
              }
              this.tableHeader.push(tables);
            } else {
              let tables = {
                title: item.displayName,
                width: "120",
                prop: item.name,
              }   
              this.tableHeader.push(tables);
            };
          });
          this.requestForm = Object.assign(this.requestForm, res.requestForm);
          this.teaSelectList = [...this.teaSelectList,...this.customSearch];
        });
        this.mixin_getCurrentPlanInfo().then((data) => {
          this.currentPlanId = data.id
          this.endAuditTime = data.endAudit
          this.endAudit = moment(data.endAudit).format('YYYY年MM月DD日 HH时mm分ss秒')
        })
        this.mixin_getSelectPlan().then(data => {
          this.$set(this.teaSelectList[0], 'data', data)
          this.requestForm.planId = data[0].id
          this.getTableList()
        })
        // 获取选项数据
        this.mixin_getSelectSchool().then((data) => {
          let newSchoolList = [
            {
              id: "",
              name: "全部",
            },
            ...data
          ]
          this.$set(this.teaSelectList[3], 'data', newSchoolList)
        })
        this.mixin_getSelectStation().then((data) => {
          let newStationList = [
            {
              id: "",
              name: "全部",
            },
            ...data
          ]
          this.$set(this.teaSelectList[4], 'data', newStationList)
        })
        this.mixin_getSelectSubject().then((data) => {
          let newSubjectList = [
            {
              id: "",
              name: "全部",
            },
            ...data
          ]
          this.$set(this.teaSelectList[6], 'data', newSubjectList)
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  .applyAudit {
    // .el-alert {
    //     margin-bottom: 24px;
    //     background: #FFF5E0;
    //     border: 1px solid #FF9500;
    //     height: 48px;
    //     line-height: 48px;
    //     box-sizing: border-box;
    //     .importantNote {
    //         font-size: 14px;
    //         color: #FF9500;
    //         margin-left: -10px;
    //         margin-top: -7px;
    //     }
    //     /deep/ .el-alert__closebtn {
    //       top: 17px;
    //       color: #FF9500;
    //     }
    // }
    /deep/ .unDistributed {
      position: relative;
      margin-left: 10px;
      &:after {
        content: ' ';
        position: absolute;
        left: -10px;
        top: 7px;
        width: 5px;
        height: 5px;
        background-color: #FE5958;
        border-radius: 50%;
      }
    }
    /deep/ .unFinish {
      position: relative;
      margin-left: 10px;
      &:after {
        content: ' ';
        position: absolute;
        left: -10px;
        top: 7px;
        width: 5px;
        height: 5px;
        background-color: #006AFF;
        border-radius: 50%;
      }
    }
    /deep/ .wait {
      position: relative;
      margin-left: 10px;
      &:after {
        content: ' ';
        position: absolute;
        left: -10px;
        top: 7px;
        width: 5px;
        height: 5px;
        background-color: #F27900;
        border-radius: 50%;
      }
    }
    /deep/ .finish {
      position: relative;
      margin-left: 10px;
      &:after {
        content: ' ';
        position: absolute;
        left: -10px;
        top: 7px;
        width: 5px;
        height: 5px;
        background-color: #1DBF60;
        border-radius: 50%;
      }
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    flex: 1;
  }
</style>
